import React from 'react';
import { useTheme } from '../theme-system/ThemeContext';
import Concept12Deck from '../home-concepts/Concept12Deck';
import HomeReel from './HomeReel';

/* The home page. The Deck layout from the concept lab, wired to the site's
   own theme toggle instead of the lab's local light/dark switch. */

const HomeDeck = () => {
  const { isDark } = useTheme();
  // Layout supplies the site footer, so the deck's own copy is turned off here.
  return (
    <>
      <HomeReel mode={isDark ? 'dark' : 'light'} />
      {/* wrapped: the deck's minHeight:100% would otherwise copy the whole page height (thousands of empty px under it) */}
      <div><Concept12Deck mode={isDark ? 'dark' : 'light'} hideFooter /></div>
    </>
  );
};

export default HomeDeck;
